export default __webpack_public_path__ + "static/media/dynamicWorks.790b1e83.jpg";